import { render, staticRenderFns } from "./transaksiupload.vue?vue&type=template&id=210e560f&scoped=true&"
var script = {}
import style0 from "./transaksiupload.vue?vue&type=style&index=0&id=210e560f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210e560f",
  null
  
)

export default component.exports